import {
  Button,
  CircularProgress,
  Dialog,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { postApiCall } from 'api/apiService';
import { Pendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import { REFUND_STATUS_AGENT } from 'constant/app.config';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { poppins400, poppins500 } from 'theme/common.style';

const ConfirmRefundPopup = (props) => {
  const {
    open,
    setConfirmDepositRequest,
    profileDetails,
    actionBuyerRefund,
    actionRefundBuyerId,
    getTableData,
    setActionBuyerId,
    setActionBuyer,
    setActionBuyerRefund,
    isTable,
    isFromBuyerRegister,

    buyerNameIndividual,
    depositDetailsData,
    buyerId,
    getDetailsData,
  } = props;
  const CommaSeprateValue = (val) => {
    return val?.toLocaleString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));

  const buyerRequestedOfferPriceIndividual =
    depositDetailsData?.depositDetails?.alreadyHeldRequestFormatted;

  const propertyId = profileDetails?.PropertyDetails?.property?.propertyId;

  const [loading, setLoading] = useState(false);

  const RefundPostCall = () => {
    setLoading(true);

    const inputData = {
      buyerId: isTable ? actionRefundBuyerId : buyerId,
      propertyId: propertyId,
    };

    postApiCall(REFUND_STATUS_AGENT, inputData)
      .then((res) => {
        if (isTable) {
          setActionBuyerId('');
          setActionBuyer('');
          setActionBuyerRefund('');
        }

        if (res?.data?.status == '1') {
          if (isTable) {
            getTableData();
          } else {
            getDetailsData();
            if (!isFromBuyerRegister) {
              getTableData();
            }
          }
          Swal.fire({
            title: res?.data?.heading,
            text: res?.data?.message,
            icon: 'success',
            confirmButtonText: 'Close',
          });
        } else {
          Swal.fire({
            title: res?.data?.heading || 'Error',
            text: res?.data?.message,
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }

        setConfirmDepositRequest(false);
      })
      .catch(() => {
        setConfirmDepositRequest(false);

        Swal.fire({
          title: 'Error',
          text: 'Something went wrong.',
          icon: 'error',
          confirmButtonText: 'Close',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={() => setConfirmDepositRequest(false)}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            // height: matchessm ? "350px" : "300px",/
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
            width: '721px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {profileDetails?.PropertyDetails?.propertyAddress?.streetName}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Confirm Refund Deposit
            </Typography>
          </Grid>
          <Grid item textAlign={'left'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '12px' : '16px',
                color: '#666666',
              }}
            >
              You are confirming the buyer{' '}
              <b>
                {isTable ? actionBuyerRefund?.buyerName : buyerNameIndividual}
              </b>{' '}
              for&nbsp;
              <b>
                {isTable
                  ? actionBuyerRefund?.formattedRequestAmount
                  : buyerRequestedOfferPriceIndividual}
              </b>{' '}
              has processed the Refund Deposit.
            </Typography>
          </Grid>

          <Grid item textAlign={'left'} marginTop={3}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '12px' : '16px',
                color: '#666666',
              }}
            ></Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? 2 : 4}
          >
            <Grid item>
              <Button
                disabled={loading}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => setConfirmDepositRequest(false)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                disabled={loading}
                variant="outlined"
                sx={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                  '&:hover': {
                    background: '#4CA4D6',
                    boxShadow: 'none', // if you want to prevent elevation/shadow change
                  },
                }}
                onClick={RefundPostCall}
              >
                Confirm
              </Button>

              {loading && (
                <CircularProgress
                  size={matchessm ? 25 : 32}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#4CA4D6',
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default ConfirmRefundPopup;
